export default __webpack_public_path__ + "static/media/FontsFree-Net-SFProText-Medium.fc3c323b.ttf";